// extracted by mini-css-extract-plugin
export default {"table":"Table_table__alEQ6","name":"Table_name__efsks","email":"Table_email__T5kDN"};